window.checkList = {
	
	edit: function(clid){
		
		var options = {
			title	: Loc.g('Modifier la liste'),
			width: 600,
			buttons	: [
				{
					text : Loc.g("Annuler"), click : function(){$(this).dialog("close");}
				},
				{
					text : Loc.g("Enregistrer"), click : function(){$("#checkListForm").submit();}
				}
			],
			callback	: function(){checkList.prepareCheckListForm();}
		};

		MyWindow.load("checkList", {action:"checkListForm", clid:clid}, options);
	},
	
	create: function(linkedtype, linkedid){
		
		var options = {
			title	: Loc.g('Nouvelle checklist'),
			width: 600,
			buttons	: [
				{
					text : Loc.g("Annuler"), click : function(){$(this).dialog("close");}
				},
				{
					text : Loc.g("Enregistrer"), click : function(){$("#checkListForm").submit();}
				}
			],
			callback	: function(){checkList.prepareCheckListForm();}
		};

		MyWindow.load("checkList", {action:"checkListForm", linkedtype:linkedtype, linkedid:linkedid}, options);
		
	},
	
	deletecheckList: function(checkListId){
		var options = {
			type:  "warning",
			buttons : [
				{
					text : Loc.g("Annuler"), 
					click : function(){
						$(this).dialog("close");
					}
				},
				{
					text : Loc.g("Supprimer"),
					click : function(){
						$(this).dialog("close");
						var datas = {action:"deleteCheckList", checkListId:checkListId};
						MyFacture.post("checkList", datas, function(data){
							$("#checkListEngine .oneCheckList[checklistid="+data.checkListId+"]").remove();

							if ($("#checkListEngine .oneCheckList").length > 0){
								$('#checkListEngine .noCheckList').hide();
							} else {
								$('#checkListEngine .noCheckList').show();
							}

						}, "json");
					}
				},
			]
		};
		
		MyWindow.alert(Loc.g("Supprimer la checklist ?"), options);
	},
	
	
	duplicateCheckList: function(checkListId){
		var options = {
			type: "confirm",
			buttons: [
				{
					text : Loc.g("Annuler"),
					click : function(){
						$(this).dialog('close');
					}
				},
				{
					text : Loc.g("Dupliquer"),
					click : function(){
						$(this).dialog('close');
						var datas = {action: "duplicateCheckList", checkListId: checkListId};
						MyFacture.post('checkList', datas, function(data){
							
							var checkList = data.checkListOneDetails;
							if ($("#checkListEngine .oneCheckList[checklistid="+checkList.id+"]").length > 0){
								$("#checkListEngine .oneCheckList[checklistid="+checkList.id+"]").replaceWith(data.checkListOne);
							} else {
								$("#checkListEngine .checkListContainer").append(data.checkListOne);
							}

							if ($("#checkListEngine .oneCheckList").length > 0){
								$('#checkListEngine .noCheckList').hide();
							} else {
								$('#checkListEngine .noCheckList').show();
							}

							MyFacture.customForm();
							checkListDisplayer.updateProgression(''+checkList.id);

						
						}, "json");
					}
				}
			]
		};

		MyWindow.alert(Loc.g("Dupliquer la checkList ?"), options);
	},
	
	
	prepareCheckListForm: function(){
		
		var formId = "checkListForm";
		var options = {success:function(data){
			var formIsOk = MyForm.processJson(data, "checkListForm");
			if (formIsOk){
				MyWindow.close();
				
				var checkList = data.checkListOneDetails;
				if ($("#checkListEngine .oneCheckList[checklistid="+checkList.id+"]").length > 0){
					$("#checkListEngine .oneCheckList[checklistid="+checkList.id+"]").replaceWith(data.checkListOne);
				} else {
					$("#checkListEngine .checkListContainer").append(data.checkListOne);
				}
				
				if ($("#checkListEngine .oneCheckList").length > 0){
					$('#checkListEngine .noCheckList').hide();
				} else {
					$('#checkListEngine .noCheckList').show();
				}
				
				MyFacture.customForm();
				checkListDisplayer.updateProgression(''+checkList.id);
			}
		}, dataType:"json"};
		var data = {action: 'recordCheckListForm'};
		MyForm.prepare(formId, "checkList&"+$.param(data), options, true);
		MyFacture.initEvent();
		
		$('#sortableCheckListEntries').sortable({
			containment : 'parent'
		});
		
	}
	
};

window.checkListBuilder = {
	
	addEntry: function(){
		
		var newEntry = $('#checkListForm .defaultcheckListEntry').clone();
		
		var nbEntries = 1 ;
		if($('#checkListForm #sortableCheckListEntries li:last-child').not('.defaultcheckListEntry').length > 0){
			 nbEntries = parseInt($('#checkListForm #sortableCheckListEntries li:last-child').not('.defaultcheckListEntry').find("input[type='text']").attr("id").split("_")[2], 10)+1;
		}
		
		
		newEntry.removeAttr('class').attr('class', 'sortableCheckListEntry');
		newEntry.find('input')
				.attr('name', 'clform_entry['+nbEntries+'][ident]')
				.attr('id', 'clform_entry_'+nbEntries+"_ident");
		
		newEntry.appendTo('#checkListForm #sortableCheckListEntries').show();
		$('#sortableCheckListEntries').sortable('refresh');
		
		$("#sortableCheckListEntries:visible").animate({ scrollTop: $("#sortableCheckListEntries:visible")[0].scrollHeight}, 100);
		
	},
	
	removeEntry: function(me){
		me.closest('li').remove();
	}
	
};

window.checkListDisplayer = {
	
	init: function(){
		
		$.each($('#checkListEngine .oneCheckList'), function(index, value){
			checkListDisplayer.updateProgressionForOne(value);
		});
		
	},
	
	updateProgression: function(checkListId){
		var value = $('#checkListEngine .oneCheckList[checklistid='+checkListId+']');
		checkListDisplayer.updateProgressionForOne(value);
	},
	
	updateProgressionForOne: function(checkLstObj){
		
		var nbCheckList = parseInt($(checkLstObj).find('input').length, 10);
		var nbCheckedList = parseInt($(checkLstObj).find('input:checked').length, 10);
		var ratio = Math.round((nbCheckedList / nbCheckList)*100);
		
		$(checkLstObj).find('.progressBar').progressbar({
			value : ratio
		});
		
		$(checkLstObj).find('.progress-label').html(ratio + " %");
		
	},
	
	completeEntry: function(checkListId, entryId){
		
		var completed = $('#checkListEngine #checkListEntry_'+checkListId+'_'+entryId).is(':checked') ? "Y" : "N";
		
		if(completed === "Y"){
			$('#checkListEngine #checkListEntry_'+checkListId+'_'+entryId).closest('.oneCheckListEntry').addClass('checked');
		} else {
			$('#checkListEngine #checkListEntry_'+checkListId+'_'+entryId).closest('.oneCheckListEntry').removeClass('checked');
		}
		
		var datas = {action:"completeEntry", checkListId:checkListId, entryId:entryId, completed:completed};

		MyFacture.post("checkList", datas, function(data){
			
			if (data.status == 'success'){
				
				checkListDisplayer.updateProgression(checkListId);
				
				var oneEntry	= $('#checkListEngine #checkListEntry_'+checkListId+'_'+entryId).closest('.oneCheckListEntry');
				
				var dateFormat = oneEntry.find('.completedDateFormatted').attr('dateformat');
				var hourFormat = oneEntry.find('.completedDateFormatted').attr('hourformat');
				
				var format = "";
				
				if (dateFormat == 'dmy'){
					format = "DD/MM/YYYY";
				} else {
					format = "MM/DD/YYYY";
				}
				
				if (hourFormat == '24'){
					format += ", HH:mm";
				} else {
					format += ", HH:mm";
				}
				
				var now	= moment().format(format);
				
				if(completed === "Y"){
					oneEntry.addClass('checked');
					oneEntry.find('.completedDate').show().find('.completedDateFormatted').html(now);
					oneEntry.find('.completedDate').find('.completePeople').html(" " + Loc.g('par') + " " + $('#currentPeople').html());
				} else {
					oneEntry.removeClass('checked');
					oneEntry.find('.completedDate').hide();
				}
				
				
			}
			
		}, "json");
		
		
	}
	
};
